import { call, put, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga'
import { REQUEST_UPLOAD } from "../actions/types";
import { upload } from '../api/image.api';
import { uploadSucceeded } from '../actions/image.actions';
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { GENERIC_ERROR_MESSAGE } from "../config/messages";
import {hideSpinner} from "../actions/loading.actions";

function* uploadSaga(action) {
    try {
        const response = yield call(upload, action.payload);
        yield put(uploadSucceeded(response.data));

    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));
    }
}

export default function* imageSaga() {
    yield takeLatest(REQUEST_UPLOAD, uploadSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/image.saga.js